import React from 'react'
import { Link } from 'react-router-dom'
import { t } from '../i18n'
import { ChevronRight } from './Icons'

/* Orange topic chip on a card: shown only when the story belongs to a topic.
   With onSelect (Moje teme) it's a button with its own label instead of a
   link to the topic page. */
export default function TopicTag({ topic, label = null, onSelect = null }) {
  const name = label || topic?.shortTitle
  if (!name) return null
  const content = (
    <>
      <span className="topic-dot" aria-hidden="true" />
      <span className="topic-tag-name">{name}</span>
      <ChevronRight size={14} strokeWidth={2.5} />
    </>
  )
  if (onSelect) {
    return (
      <button
        type="button"
        className="topic-tag topic-tag-button"
        aria-label={t('card.topicLabel', { name })}
        onClick={onSelect}
      >
        {content}
      </button>
    )
  }
  return (
    <Link
      to={`/tema/${topic.slug}`}
      state={{ entry: 'card_tag' }}
      className="topic-tag"
      aria-label={t('card.topicLabel', { name })}
    >
      {content}
    </Link>
  )
}
